<template>
  <li class="dropdown notification-list">
    <a
      class="nav-link dropdown-toggle arrow-none text-decoration-none"
      href="#"
      @click.prevent="toggleNotificationDropDown"
    >
      <i class="mdi mdi-flag-outline mdi-28px noti-icon"></i>
    </a>
    <dropdown item-class="dropdown-lg" :show="showContainer">
      <div v-for="lang in langs" :key="lang.key" class="dropdown-item noti-title" @click="switchToLanguage(lang.key)">
        <button class="dropdown-item">
          <span class="align-middle"> {{ lang.name }} {{ lang.emoji }} </span>
        </button>
      </div>
    </dropdown>
  </li>
</template>

<script setup>
import { ref, computed, onBeforeUnmount, onMounted } from 'vue'

import { useI18n } from 'vue-i18n'

import Dropdown from '@/components/Dropdown.vue'

const { locale } = useI18n()

const showNotificationContainer = ref(false)
const langs = ref({
  tr: {
    key: 'tr',
    name: 'Türkçe',
    emoji: '🇹🇷'
  },
  ro: {
    key: 'ro',
    name: 'Română',
    emoji: '🇷🇴'
  },
  en: {
    key: 'en',
    name: 'English',
    emoji: '🇬🇧'
  }
})

const toggleNotificationDropDown = () => {
  showNotificationContainer.value = !showNotificationContainer.value
}

const switchToLanguage = lang => {
  locale.value = lang
  localStorage.setItem('language', lang)
}

const close = e => {
  if (!e.target.contains(e.target)) {
    showNotificationContainer.value = false
  }
}

onMounted(() => {
  window.addEventListener('click', close)
})

onBeforeUnmount(() => {
  window.removeEventListener('click', close)
})

const showContainer = computed(() => (showNotificationContainer.value ? 'show' : ''))
</script>
